<template>
  <div>
    <h1>Terms Of Service</h1>

    <p>of the rpgRoot Website and System</p>

    <b>§ 1. General provisions</b>
    <p>
      The Terms of Service provide the terms and conditions of use of the Website and the rpgRoot System, including
      conditions for providing services by electronic means, terms of executing and terminating the Contracts, and
      complaints procedure.

      Using the Website and the Services available through the Website (including access to the rpgRoot System) requires
      reading and accepting these Terms of Service.

      The Service Provider is Bartłomiej Kalemba registered office in Tarnowskie Góry, at ul. Aleja Kwiatów 21, 42-606
      Tarnowskie Góry, kept by Central Registration and Information on Business Activity, NIP [tax id]: 6452484324, REGON
      [statistical id]: 387037180, email: support@rpgRoot.com.

      The Service Provider makes the following services available on the Website:
    </p>

    <ol>
      <li>providing access to the rpgRoot System;</li>
      <li>providing access to the Website;</li>
      <li>providing access to the Website’s functionalities;</li>
      <li>providing access to the rpgRoot System’s functionalities;</li>
      <li>providing access to the rpgRoot System’s functionalities;</li>
    </ol>

    <b>§ 2. Definitions</b>
    <p>The capitalised terms used herein have the following meanings:</p>

    <ol>
      <li>Account means a part of the Website that constitutes a set of resources and rights assigned to the Creator or
        Subscriber respectively, accessible after signing in (or clicking the Link, in case of the Subscriber);</li>

      <li>Act on Consumer Rights means the Act of 30 May 2014 on consumer rights (consolidated text of 21 February 2020,
        Journal of Laws of 2020, item 28, as amended);</li>

      <li>Act on Copyright means the Act of 4 February 1994 on Copyright and Related Rights (consolidated text of 14 June
        2021, Journal of Laws of 2021, item 1062, as amended);</li>

      <li>Act on Provision of Electronic Services means the Act of 18 July 2002 on the provision of services by electronic
        means (consolidated text, Journal of Laws of 3 March 2020, item 1219, as amended).</li>

      <li>Civil Code means the Act of 23 April 1964, the Civil Code (consolidated text of 8 October 2020, Journal of Laws
        of 2020, item 1740, as amended);</li>

      <li>Consumer means an individual who makes a legal transaction with an Entrepreneur that is not related directly to
        his/her economic or professional activity;</li>

      <li>Contract means a contract for the provision of services by electronic means concluded remotely between Service
        Provider and Creator or User, the subject and content of which are defined by the provisions of Terms of Service,
        Price List and Instructions;</li>

      <li>Controller of the Subscribers’ Data means the Creator that under the provisions of Article 12 of the Terms of
        Service or a separately executed agreement, entrusts the Processor with the Subscribers’ Personal Data for their
        processing, to perform the Contract for the use of the rpgRoot System;</li>

      <li>Creator means an individual with full legal capacity, a legal person or an organizational unit without legal
        personality, which is granted legal capacity by law, using the Services, including the functionality of the
        rpgRoot System, under the Contract;</li>

      <li>Entrepreneur means an individual who is not a Consumer, a legal person or an organizational unit without legal
        personality, which is granted legal capacity by law, conducting business activity, including partners in a civil
        partnership to the extent of their business activities;</li>

      <li>Fee means the remuneration paid by the Creator to the Service Provider in an amount specified in the Price List
        (respectively to the selected option) for the use of paid Services in a given Settlement Period;</li>

      <li>GDPR means the Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the
        protection of natural persons in relation to the processing of personal data and on the free movement of such data
        and repealing Directive 95/46/EC (General Data Protection Regulation);</li>

      <li>Instructions mean any information and notices concerning a description of the current functionalities,
        capabilities, and working principles of the rpgRoot System placed on the Website;</li>

      <li>Link means a coded link generated and individually assigned to the Subscriber, the clicking of which confirms
        the creation of the Account and enables the Subscriber to access it; the Subscriber receives the Link in an email
        sent after the purchase of the Creator ‘s product or service using the rpgRoot System;</li>

      <li>rpgRoot System means an IT solution (software together with elements that are not software) made available by
        the Service Provider to Creator s in the SaaS model, equipped with a set of functionalities referred to in Terms
        of Service, Price List and Instructions, aimed at supporting the automation of business processes of Creators,
        including among others by providing tools to promote and sell newsletters, online courses and other products and
        services of the Creators (sales platforms, landing page platforms, etc.), as well as functionalities to improve
        communication with customers (links, archives, etc.) and ensuring the integration of sales platforms with payment
        and invoicing systems, etc.;</li>

      <li>Personal Data means any information related to an identified or identifiable natural person;</li>

      <li>Price List means the information on the Fees for paid Services made available on the Website, constituting an
        integral part of this Terms of Service;</li>

      <li>Privacy Policy means the document setting out the terms of processing Personal Data, available at:
        https://rpgroot.com/#/privacy-policy/;</li>

      <li>Processor means an entity processing Personal Data within the meaning of Article 28 of the GDPR, on behalf of
        the controller of such data according to a data entrustment agreement, being herein the Service Provider
        concerning the Personal Data.</li>

      <li>SaaS means the software as service installed and maintained entirely within the Service Provider’s
        infrastructure;</li>

      <li>Service Provider means the entity providing Services under the Terms of Service, Price List and Instructions,
        i.e. Bartłomiej Kalemba registered office in Tarnowskie Góry, at ul. Aleja Kwiatów 21, 42-606
        Tarnowskie Góry, kept by Central Registration and Information on Business Activity, NIP [tax id]: 6452484324,
        REGON
        [statistical id]: 387037180, email: support@rpgRoot.com.
      </li>
      <li>Services mean free of charge and chargeable services provided electronically by the Service Provider to Creators
        and Users under the Terms of Service, Price List and Instructions;</li>

      <li>Settlement Period means a period of performance of the paid Service for which the Fee is due, depending on its
        option selected by the Creator, as specified in the Price List, e.g., one month, quarter, half a year, one year,
        etc.;</li>

      <li>Subscriber means a customer of a Creator receiving access to the Subscriber’s Account after the purchase of
        Creator’s product or with the use of the rpgRoot System on terms and conditions specified in a separate agreement
        concluded with the Creator;</li>

      <li>Terms of Service mean these terms for the provision of services by electronic means, constituting a model
        agreement and complying with the obligation referred to in Article 8 section 1 item 1) of the Act on Provision of
        Electronic Services;</li>

      <li>User means a visitor to the Website, including subscribing to the Newsletter;</li>

      <li>Website means the website available at the Internet address https://rpgroot.com/ and its subdomains addresses.
      </li>
    </ol>

    <b>§ 3. Types and scope of the Services provided</b>
    <p>The Service Provider provides the following Services via the Website:</p>
    <ol>
      <li>creation, maintenance, and deletion of the Account (including the Creator’s Account and the Subscriber’s
        Account),</li>

      <li>access to the rpgRoot System and use of its functionalities,</li>

      <li>newsletter,</li>

      <li>online chat,</li>

      <li>blog.</li>

      <li>The Services are free of charge (access to the trial version of the rpgRoot System, Account, Newsletter, blog,
        online chat) and chargeable (access to the rpgRoot System in the selected option after the trial period).</li>

      <li>The Service Provider shall provide the Services continuously, seven days a week, subject to the provisions of
        section 4 below.</li>

      <li>The Service Provider reserves the right to temporarily suspend the Services’ provision due to maintenance or
        repair works and in connection with the modernisation or reconstruction of the Website or the rpgRoot System. The
        Service Provider shall make every possible effort to ensure that interruptions in the provision of the Services
        are not disruptive (including that they take place during the night hours and last as short as possible).
        Notification of any planned, temporary suspension of the rpgRoot System shall be provided to the Creators via the
        Account or electronically to the email provided during the registration.</li>

      <li>The Service Provider does not provide Services to Subscribers unless they are also Creators or Users. Any
        actions taken by the Subscriber using the rpgRoot System are related to the execution of separate agreements
        concluded between the Creator and the Subscriber to which the Service Provider is not a party. The preceding means
        that the entity liable towards the Subscriber for improper performance or non-performance of the agreement is
        exclusively the Creator or another third party participating in the performance of this agreement.</li>

      <li>The Service Provider shall not be liable for disruptions in access to the rpgRoot System and the interruptions
        in the performance of the Services related to them, and shall not be responsible for damage resulting from the
        loss of data by the Creator or the Subscriber, caused by:</li>

      <li>force majeure (understood as a sudden, unpredictable event, beyond the Service Provider’s control, such as fire,
        flood, natural disasters, epidemics, earthquake),</li>

      <li>failure of the Creator ‘s or the Subscriber’s equipment,</li>

      <li>power cuts or the Internet connection outage,</li>

      <li>threats connected with the use of the network by the Creator (hacker attacks, viruses, etc.),</li>

      <li>unauthorised interference by the Creator, the Subscriber or third parties,</li>

      <li>faulty operation of telecommunication systems and software installed on the Creator’s or the Subscriber’s
        computer equipment;</li>

      <li>Creator or the Subscriber being unaware or failing to comply with the Terms of Service and applicable law.</li>

      <li>Any liability of the Service Provider related to the non-performance or improper performance of the Services
        (including for loss of data) shall be limited to the actual losses incurred by the Creator and shall not exceed
        the amount of the Fee paid in a given Settlement Period.</li>
    </ol>

    <b>§ 4. Terms of use of the Website and the rpgRoot System</b>

    <ol>
      <li>Using the Website and the rpgRoot System requires meeting the following minimum technical requirements:</li>

      <li>having a device with the Internet connection; the Service Provider does not cover the costs of connecting the
        device to the Internet, as the user of the Services bears them according to the network operator rates;</li>

      <li>having an up to date version of a web browser that enables the proper display of the Website resources (e.g.,
        Firefox, Chrome, Safari); the Service Provider recommends that these are the latest stable versions of the above
        browsers;</li>

      <li>having an active email address.</li>

      <li>The Creator and the User undertake to use the Website and the rpgRoot System in a manner consistent with their
        intended purpose, the Terms of Service, the Instructions, and in accordance with the applicable law, rules of
        social conduct, and best practices. The use of resources and functions available on the Website and the rpgRoot
        System for purposes other than those specified in the Contract requires a separate, prior consent of the Service
        Provider.</li>

      <li>By accepting these Terms of Service, the Creator and the User undertake in particular to:</li>

      <li>comply with the prohibition of posting unlawful content, understood as, among other things: prohibition of
        posting content that is offensive, untrue, immoral, violating good practices, promoting violence and hatred,</li>

      <li>not to undertake actions aimed at disrupting the functioning of the Website or rpgRoot System and gaining access
        to information or data not intended for the Creator or the User,</li>

      <li>not to undertake any other actions contrary to the applicable laws, good practices, or violating rights and
        personal interests of the Service Provider and third parties (including intellectual property rights).</li>

      <li>If the Creator or User violates these Terms of Service, the applicable laws or acts to the detriment of the
        Service Provider, other Creators, Users, or third parties in any other way, the Service Provider shall be entitled
        to restrict or terminate their access to the Website (in case of the Creator also access to the rpgRoot System),
        with immediate effect. The Creator or User shall be notified immediately of the action taken. Re-access to the
        Website (including access to the rpgRoot System) requires the prior consent of the Service Provider.</li>

      <li>If the event referred to in section 4 above occurs, the Creator or the User shall undertake immediate actions to
        eliminate the reason for the restriction or blocking of access to the Services; otherwise, the Service Provider is
        entitled to terminate the Contract with immediate effect (without notice).</li>

      <li>The Service Provider hereby informs the Creators and Users that the use of services provided electronically, via
        the Internet is connected with the following threats:</li>

      <li>malware;</li>

      <li>various types of applications or scripts having harmful, criminal, or malicious effects concerning the ICT
        system of the network user, such as viruses, worms, trojans (Trojan horses), keyloggers, dialers;</li>

      <li>spyware;</li>

      <li>trackers;</li>

      <li>user activities that collect information about the user and send it usually without the user’s knowledge or
        consent to the developer of the software;</li>

      <li>spam, i.e., unwanted and unsolicited emails sent simultaneously to many recipients;</li>

      <li>phishing for confidential personal information (e.g., passwords) by impersonating a trustworthy person or
        institution;</li>

      <li>intrusions into a user’s IT system by using, among others, such hacking tools as exploit rootkits.</li>

      <li>The Service Provider informs Creators and Users that it applies modern means to protect the Website and the
        rpgRoot System against unauthorised actions of third parties. Nevertheless, the Service Provider advises the
        Creators and Users that they also take steps to mitigate as much as possible the potential risk of the threats
        referred to in section 6 above, including to:</li>

      <li>equip their electronic devices used to receive the Services with anti-virus software and keep it up to date;
      </li>

      <li>regularly scan the entire system with anti-virus software;</li>

      <li>have an active firewall;</li>

      <li>keep software up to date;</li>

      <li>not open email attachments of unknown origin;</li>

      <li>read the information contained in application installation windows and their licences;</li>

      <li>use original system and application from legal sources.</li>
    </ol>

    <b>§ 5. Account</b>

    <ol>
      <li>Registration and maintenance of an Account are free of charge.</li>

      <li>The Creator may register an Account by filling in the registration form available on the Website, providing
        his/her data in line with the facts (name, surname, and email), and accepting the Terms of Service and Privacy
        Policy.</li>

      <li>The Contract for maintaining the Creator’s Account is concluded between the Service Provider and the Creator
        upon activation of the Account, which takes place after filling in the form and clicking on the button “Create the
        Account.”</li>

      <li>The Contract for maintaining the Subscriber’s Account between the Service Provider and the Creator is concluded
        upon clicking by the Subscriber on the Link, which takes place after the purchase of the Creator’s product or
        service using the rpgRoot System.</li>

      <li>Signing in to the Creator’s Account requires providing a login and password in the login form available on the
        Website. The login is the email address provided by the Creator. The Creator creates the password individually in
        the registration process or appropriately through editing the Account’s settings.</li>

      <li>Signing in to the Subscriber’s Account requires, in the case of the first visit – clicking the Link, and in the
        case of subsequent visits and setting up the login and password by the Subscriber by editing the settings of the
        Account – entering these data in the login form available on the Website.</li>

      <li>The Creator undertakes (and shall oblige the Subscriber respectively) to keep the information enabling access to
        the Account confidential. To maintain the login security, the Service Provider recommends creating a strong login
        password, changing it every 30 days, logging out of the Account, and closing the web browser after using the
        rpgRoot System. The Service Provider is not responsible for the consequences of the Creator or Subscriber sharing
        the password with third parties.</li>

      <li>The Account is created for an indefinite term. Creator is entitled to delete the Account at any time without
        providing a reason. For this purpose, an email should be sent to the following address: support@rpgroot.com.</li>

      <li>The Service Provider is entitled to block or delete the Account in circumstances referred to in Article 4
        sections 4 and 5 hereof.</li>

      <li>Change or recovery of the password is possible through the password recovery or change function available on the
        Website.</li>

      <li>The Creator may supplement or edit information about themself by editing individual sections of the Account.
        Still, each time undertakes to provide truthful, current data that does not violate the rights of third parties.
      </li>

      <li>The Subscriber may set and edit the login and password, update the subscription to the Creator’s services by
        editing the appropriate section of the Account (cancellation of the subscription, change of card data), and access
        through the Account to additional materials added by the Creator.</li>

      <li>The Creator may upload the Account only with the content they own the right to, including the economic
        copyrights within the meaning of the Act on Copyright. If any claims against the Service Provider resulting from
        the breach of Creator ‘s economic rights or personal copyright to the content posted by the Creator in the rpgRoot
        System are raised by third parties, the Creator shall indemnify the Service Provider from liability resulting from
        such claims and shall cover all expenses incurred in connection with such claims.</li>

      <li>Entering Subscribers’ Personal Data into the rpgRoot System (setting up the Account for a Subscriber) in
        connection with the purchase of the Creator’s products or services and using the rpgRoot System on terms specified
        in a separate agreement executed between the Creator and the Subscriber, constitutes the entrustment of the
        Subscribers’ Personal Data to the Service Provider by the Creator on terms specified in Article 12 hereof (data
        entrustment agreement).</li>

      <li>By accepting the Terms of Service and using the rpgRoot System, the Creator represents that is the Controller of
        the Subscribers’ Personal Data posted on rpgRoot System and that is fully liable towards them for meeting the
        obligations arising from the GPDR and other applicable laws. Including, in particular, the disposal and proper
        documentation of the legal base for the processing of Subscribers’ Personal Data entrusted to the Service Provider
        and the fulfilment of information obligations.</li>

      <li>The Creator is obliged to acquaint the Subscribers with the Terms of Service and Privacy Policy, draw up and
        make terms of sale of its products or services using the functionality of the rpgRoot System available to the
        Subscribers free of charge, and set out the conditions for the processing of the Subscriber’s Personal Data.</li>
    </ol>

    <b>§ 6. rpgRoot System</b>

    <ol>
      <li>The Creator’s use of the rpgRoot System functionalities requires prior registration of the Account, and in the
        case of paid services – placing an order and paying the Fee.</li>

      <li>Within the rpgRoot System, the Service Provider provides the following Services:</li>

      <li>free access to the rpgRoot System trial version,</li>

      <li>paid access to the selected variant of the rpgRoot System in line with the Price List.</li>

      <li>The trial version of the rpgRoot System:</li>

      <li>requires setting up and signing in with the Account and placing an order for access to the trial version;</li>

      <li>is available on a one-off basis;</li>

      <li>can be switched off by the Creator by submitting to the Service Provider the resignation from the use of the
        trial version or by deleting the Account;</li>

      <li>is available until the expiry of its duration, unless the Creator places an order for paid Services within the
        chosen option. The above is tantamount to the fact that access to the paid Services is not automatically activated
        after the expiry of the trial version use period (no Fee is charged).</li>

      <li>The use of paid access to the rpgRoot System:</li>

      <li>requires signing in with the Account, placing an order for a particular type of the Services and making a
        payment under the Price List and the terms specified in Article 8 hereof;</li>

      <li>activation of the paid Service shall take place immediately after crediting the Service Provider’s account;</li>

      <li>if the Settlement Period expires, the Contract for the provision of the paid Services shall be extended if the
        Creator places a new order under the terms referred to in item 1) above;</li>

      <li>before the expiry of the Settlement Period, the Service Provider shall inform the User of expiry of the
        Settlement Period and a requirement to make a</li>
      <li>subsequent payment;</li>

      <li>if during the Settlement Period, the Creator intends to change a type of the Services, they may notify the
        Service Provider of such a need by sending an email to: support@rpgroot.com, and then make an additional payment
        to the Fee applicable for the remaining Settlement Period, proportional to the difference in the Fee amount. If
        during the Settlement Period, the Service type is changed to a cheaper one, the difference in the Fee shall not be
        returned to the Creator;</li>

      <li>The Contract for the provision of the Service of paid access to the rpgRoot</li>
      <li>System is executed for a period valid for a given type /option of the Services.</li>

      <li>If the Creator breaches obligations referred to in Article 4 section 3 hereof, or the circumstances referred to
        in Article 4 section 5 hereof occur, the Service Provider is entitled to terminate the Contract for the provision
        of the access Services to rpgRoot System, without notice.</li>

      <li>As part of the functionality of the rpgRoot System, the Service Provider provides the Creator with the
        possibility to integrate rpgRoot with external entities, including ActiveCampaign, MailChim, MailerLite,
        ConvertKit, Fakturownia i Firma, etc. To integrate rptRoot System properly, the external services providers may
        require the Creator to register an account to use their services and enter into separate agreements with them.
      </li>

      <li>The Service Provider is not responsible for the malfunction of external entities, does not act as an
        intermediary in the transactions, and is not a party to the agreement between the Creator and external entities.
        In addition, the Service Provider is not responsible for the possible removal of materials from external websites
        and recommends the Creator to have backup copies of materials posted on the external providers’ websites.</li>

    </ol>
    <b>§ 7. Newsletter</b>
    <ol>

      <li>The Service Provider shall provide a free of charge Service consisting of sending information on the following
        topics: creation and management of paid newsletters, subscription sale of access to content, new functionalities
        of the rpgRoot System, and promotions of the Services (hereinafter: “Newsletter”) via email to the email address
        provided by the User during registration.</li>

      <li>The Newsletter service is provided free of charge for an indefinite term.</li>

      <li>All Newsletter content and graphics are subject to copyrights or other rights vested in the Service Provider or
        third parties and are protected by law. Copying, modifying, and using them in a manner contrary to their purpose
        or without the consent of the Service Provider may constitute an infringement of law.</li>

      <li>Activation and signing up for the Newsletter requires performing the following actions: (i) providing in an
        electronic form available on the Website the following data: name and email address, (ii) reading the Terms of
        Service (in particular in part related to the Newsletter) and Privacy Policy and (iii) activating the Newsletter
        Service by clicking on the “Sign up” button.</li>

      <li>By providing the User’s email address and clicking on the “Subscribe” button, the User agrees to receive
        commercial information to the email address provided, within the scope referred to in section 1 above.</li>

      <li>The User may deactivate the Newsletter Service at any time, which constitutes termination of Contract for the
        Newsletter Service. Deactivation of the Newsletter Service requires clicking on the link “Unsubscribe” included in
        the email, which results in the discontinuation of sending the Newsletter by the Service Provider to the email
        address indicated by the User.</li>

      <li>The User may re-subscribe to the Newsletter at any time.</li>
    </ol>
    <b>§ 8. Payments</b>
    <ol>

      <li>The Creator shall pay for the paid Service in advance in accordance with the Price List. The prices given are
        expressed in Polish zloty [PLN] and are net prices.</li>

      <li>Due to the nature of payment methods available on the Website, the Creator shall pay immediately for paid
        Services, i.e., immediately after placing the order; otherwise, the Service Provider has the right to cancel the
        order.</li>

      <li>If the Services type is not specified in the valid Price List, the Creator shall be bound by a personalised
        price list corresponding to the content of a separate agreement executed with the Service Provider.</li>

      <li>The Service Provider enables making payments in the following modes:</li>

      <li>online payments made via the Website by payment card (Visa, American Express, Mastercard…), the number of which
        is entered by the Creator while placing an order for paid Services, implemented and supported using the
        functionality of:</li>

      <li>the Stripe platform available at stripe.com; the entity providing payment services is Stripe Inc. with
        registered office at 510 Townsend Street, San Francisco, CA 94103, USA;</li>

      <li>charging the Creator’s payment card automatically for subsequent months of subscription (revolving payments) –
        the amount of the revolving payment is specified when placing an order, it is also displayed in the Account; the
        Creator agrees to have his/her payment card charged in accordance with the placed order and may at any time
        withdraw his/her consent to revolving payments by using the appropriate functionalities of the Website or
        functionalities made available by third parties.</li>

      <li>The moment of payment is the payment confirmation submitted to the Service Provider by the payment operator.
      </li>

      <li>If a need to refund for a transaction made by the Creator with a payment card arises, the Service Provider shall
        refund the bank account assigned to the Creator’s payment card.</li>

      <li>The Service Provider shall bear the costs related to the payment processing.</li>

      <li>The Service Provider shall issue an invoice to the Creator based on the data provided during registration of the
        Account. If the Creator is a VAT payer, they shall provide its tax id and indicate whether to issue a VAT invoice
        during the registration or in the order.</li>

      <li>The Service Provider shall deliver the invoice to the email provided by the Creator within seven days of receipt
        of the payment.</li>

      <li>The Creator agrees to receive invoices from the Service Provider electronically under Article 106 n (1) of the
        Act of 11 March 2004 on value-added tax. Any changes to the Fees shall be announced on the Website by publishing
        the current Price List. Modification of the Price List does not affect the Fees paid by the Creator under the
        Contract concluded before the announcement of the changed Price List.</li>
    </ol>

    <b>§ 9. Termination of the Contract</b>
    <ol>

      <li>The Contract for the Services shall be terminated:</li>

      <li>with reference to the Account Service – at the moment of submission by the Creator of an instruction to delete
        the Account (by making changes to the Account or by sending a declaration of the Account deletion to the Service
        Provider’s email address) or as a consequence of deleting the Account by the Service Provider in connection with
        the termination of the Contract.</li>

      <li>with reference to the Newsletter Service – upon unsubscribing from the Newsletter by the User or upon the
        termination of the service by the Service Provider;</li>

      <li>with reference to the rpgRoot System trial version access Service – upon expiry of its duration and in
        connection with failure to pay the Fee for the paid Service;</li>

      <li>with reference to the rpgRoot System paid access Service – upon the end of the term for which the Service was
        purchased and in the event of Creator’s failure to continue the Contract, which shall be understood as a failure
        to pay the Fee for the next Settlement Period or cancellation of the recurring payment.</li>

      <li>The Creator is entitled to terminate the Contract concerning access to the rpgRoot System at any time by
        submitting a statement including the will to terminate the Contract to the email address of the Service Provider:
        support@rpgroot.com or by deleting the Account. In such a case, the paid Contract expires at the end of the
        current Settlement Period and any Fees previously charged shall not be</li>

      <li>refunded.</li>

      <li>The Service Provider is entitled to terminate the Contract without notice in case of:</li>

      <li>the provision by the Creator or User of false and incomplete data necessary for the execution of the Contract,
      </li>

      <li>justified suspicion or finding that the Creator or User uses the Services in a manner contrary to these Terms of
        Service or in a way violating generally applicable provisions of law or the rights of third parties, including in
        particular a violation by the Creator or User of the obligations set out in Article 4 section 3 hereof or in the
        situation referred to in Article 4 section 5 hereof.</li>

      <li>The Service Provider is entitled to stop providing the Services for a good cause, understood as significant
        financial and business reasons (including change in the profile of activity and scope of the services offered),
        changes in legislation directly affecting the Service Provider’s business, or Service Provider’s ceasing to
        operate. The Service Provider shall give no less than 60 days’ notice of planned termination of Services related
        to rpgRoot via the Website and e-mail.</li>

      <li>In case of Contracts executed for a Settlement Period longer than 60 days, the Service Provider shall reimburse
        the Creator for the Fees paid for the period exceeding 60 days.</li>
    </ol>

    <b>§ 10. Complaints procedure</b>
    <ol>
      <li>In the event of concerns about the functioning of the rpgRoot Website or irregularities in the provision of the
        Services by the Service Provider, the Creator or User may file a complaint by sending it to the following email
        address: support@rpgroot.com.</li>

      <li>The complaint shall indicate :</li>

      <li>login/e-mail address assigned to the Creator or User and their contact details,</li>

      <li>the subject matter of the complaint – indication of irregularities, date of their occurrence and duration,</li>

      <li>proposed manner of resolving the complaint.</li>

      <li>Before the complaint is considered, the Service Provider may request the Creator or the User to supplement the
        complaint if the information referred to in section 2 above requires clarification to consider the complaint
        properly.</li>

      <li>The consideration of the complaint shall take place immediately but no later than within fourteen days of
        receipt of the complaint by the Service Provider. The Service Provider shall notify the Creator or User of the
        manner of settlement electronically to the email address provided by the Creator (in case of the Creator, the
        email address assigned to the Account).</li>

      <li>Any other comments on the functioning of the Website and the rpgRoot System and questions regarding the Services
        should be directed via email to the following email address: support@rpgroot.com.</li>
    </ol>

    <b>§ 11. Technical support</b>

    <ol>
      <li>During the Contract term and as part of the Fee, the Creator may use the Service Provider’s technical support in
        relation to the Services.</li>

      <li>To obtain the technical support, one shall report the issue to the following email address: support@rpgroot.com,
        indicating the type of irregularities and bugs.</li>

      <li>The Service Provider shall respond to the reported issue no later than 72 hours of the notification receipt.
      </li>

      <li>The Service Provider’s technical support does not apply to:</li>

      <li>components subject to independent modification by the Creator,</li>

      <li>errors resulting from the Creator ‘s unauthorised interference with the Service settings,</li>

      <li>issues resulting from the Creator ‘s failure to meet the technical requirements necessary to use the Service.
      </li>
    </ol>

    <b>§ 12. Entrustment of Personal Data processing (entrustment agreement)</b>
    <ol>

      <li>1) Personal Data processing entrustment</li>

      <li>Pursuant to Article 28 of the GDPR, the Controller of Subscribers’ Data entrusts the Processor with the
        Subscribers’ Personal Data for processing, under the terms and for the purpose referred to in this Article 12.
      </li>

      <li>The Processor undertakes to process the Personal Data entrusted to it, solely upon the documented order of the
        controller (understood as the entrustment agreement, the content of which is specified in this Article 12 hereof),
        in accordance with the GDPR and other provisions of generally applicable law.</li>

      <li>The Processor guarantees the implementation of appropriate technical and organisational measures to ensure an
        adequate level of protection corresponding to the risks involved in the processing of Personal Data so that the
        processing meets the requirements of the GDPR and effectively protects the rights of data subjects.</li>

      <li>The Controller of the Subscribers’ Data declares that it is authorised to process the data to the extent they
        have been entrusted to the Processor, particularly it has complied with all steps required by the GDPR and other
        applicable legislation and has appropriate legal basis for the processing (e.g. data subject’s consent, if
        needed).</li>

      <li>2) The scope, purpose of the entrustment agreement, and the term of processing</li>

      <li>The Controller of the Subscribers’ Data shall entrust the following Personal Data of the Subscribers to the
        Processor: first name, surname, email address, registered office/headquarters, company name, and tax ID and other
        information necessary to use the functionalities of the rpgRoot System. The scope of entrustment depends on the
        functionalities available within the Services’ types; the entrustment may be extended or limited by the Controller
        of the Subsribers’ Data at any time. The Controller of the Subscribers’ Data limitation or extension of the scope
        of entrustment may take place by sending information on the subject to the Processor in electronic form (to email
        address: support@rpgroot.com). In case of no response from the Processor within five working days from the date of
        sending the email, one shall assume that the Processor accepted the change in the scope of the entrustment.</li>

      <li>The Personal Data entrusted by the Controller of the Subscriber’s Data shall be processed by the Processor
        solely for the proper performance of the Contract by the Processor, including enabling access to the rpgRoot
        System, the use of its functionalities, and creating backups for the term required for the performance of the
        Contract.</li>

      <li>The period of processing of the entrusted data by the Processor shall not be longer than the period required to
        ensure proper provision of the Services, i.e., from the moment of creating an Account until six months after
        cancelling (deleting) the Account. This period is related to the existence of backups of the Website, enabling the
        Service Provider to maintain data integrity while performing the Services. The data processing period may be
        longer if Polish or European Union law imposes such obligation on the Service Provider.</li>

      <li>3) Obligations of the Processor</li>

      <li>The Processor undertakes to exercise due care in processing the Personal Data entrusted to it.</li>

      <li>The Processor undertakes to grant personal authorisations for data processing to all persons processing the data
        entrusted to it for the performance of this entrustment agreement and to train them in data protection. It shall
        also ensure that the persons authorised by it to carry out the processing shall be bound by the confidentiality
        obligation of the data processed, which shall be extended to the employment or cooperation period of such persons
        with the Processor and the period following their termination.</li>

      <li>The Processor undertakes to keep a register of all categories of Personal Data processing operations carried out
        on behalf of the Controller of the Subscribers’ Data.</li>

      <li>Upon completion of the Services related to the processing of the data entrusted to it, the Processor shall
        return the Subscribers’ Personal Data to the Controller and delete any existing copies thereof or send
        confirmation of their destruction in electronic form, unless European Union or member state law imposes an
        obligation to store the Personal Data.</li>

      <li>As far as possible, the Processor shall support the Controller of the Subscribers’ Data to the extent necessary
        to fulfil the obligation to answer the data subject’s requests and comply with the obligations set out in Articles
        32 to 36 of the Regulation (GDPR).</li>

      <li>In case of breach of the protection of Personal Data entrusted to it, the Processor shall immediately notify the
        violation to the Controller of the Subscribers’ Personal Data. Until the instructions regarding the data breach
        are provided to the Processor, the Controller of the Subscribers’ Data shall, without undue delay, take all
        measures to mitigate and remedy the adverse effects of the breach.</li>

      <li>The Processor shall document any breach of the protection of the Subscribers’ Personal Data entrusted to it by
        the Controller of the Subscribers’ Data, including the circumstances of the breach, its effects, and the remedial
        actions taken, and shall make this documentation available to the Controller of the Subscribers’ Data.</li>

      <li>The Processor shall be responsible for the actions of its employees and other persons assisting it in the
        Personal Data processing as for its own actions and omissions.</li>

      <li>The Processor shall immediately notify the Controller of the Subscribers’ Data of any proceedings (in particular
        administrative or judicial) regarding the processing of the Personal Data specified in this entrustment agreement,
        any administrative decision or ruling regarding the processing of such data addressed to the Processor, as well as
        planned, if known, or carried out checks and inspections regarding the processing of such Personal Data at the
        Processor, in particular by the inspectors authorised by Data Protection Authority. This section 9 shall apply
        only to Personal Data entrusted to the Processor by the Controller of the Subscribers’ Data.</li>

      <li>The Processor shall keep confidential all information, data, materials, documents, and Personal Data received
        from the Controller of the Subscribers’ Data and persons it cooperates with and data obtained in any other way,
        whether intentional or accidental in oral, written, or electronic form (“Confidential Data”).</li>

      <li>In connection with the commitment to keep the Confidential Data confidential, the Processor undertakes not to
        use them, disclose or make available without the written consent of the Controller of the Subscribers’ Data, for
        any purpose other than the performance of the Contract, unless the applicable law or the Contract require to
        disclose them.</li>

      <li>At the request of the Controller of the Subscribers’ Data, the Processor shall make available any information
        required to demonstrate that it has complied with its obligations under the entrustment agreement and applicable
        law.</li>

      <li>4) Further data entrustment</li>

      <li>The Controller of the Subscribers’ Data grants consent to the Processor to further entrust the Subscribers’
        Personal Data processing referred to in section 2 item 1) of this Article 12 to the technology providers. i.e.,
        Google LLC 1600 Amphitheatre Parkway Mountain View, CA 94043 United States more information on data processing;
        https://firebase.google.com/terms/data-processing-terms for the purposes related to the performance of the
        Contract, including in connection with the provision of the hosting service.</li>

      <li>The sub-processing referred to in item 1) above is solely for ensuring the proper and secure operation of the
        MailngR System and the provision of the Services in accordance with the Contract.</li>

      <li>The Google Cloud data centres where the data are stored are located in EU member states (Belgium and the
        Netherlands), where adequate protection is provided. Details regarding the level of protection and compliance with
        the GDPR are available at: https://cloud.google.com/security/compliance/offerings#/regions=EMEA.</li>

      <li>The Processor is entitled to entrust the Personal Data covered by this entrustment agreement for further
        processing to another subcontractor to perform the Contract, upon Controller of the Subscribers’ Data prior
        written consent, also in an electronic form.</li>

      <li>The subcontractor referred to in item 3) above shall fulfil the same guarantees and obligations as those imposed
        on the Processor (Service Provider) in this entrustment agreement.</li>

      <li>5) Liability of the Processor</li>

      <li>The Processor shall be responsible for the provision or use of Subscribers’ Personal Data in breach of this
        entrustment agreement, particularly for making the Personal Data entrusted to processing available to unauthorised
        persons.</li>

      <li>If the Processor does not comply with the obligations imposed on it by the GDPR or acts outside of or contrary
        to the lawful instructions of the Controller of the Subscribers’ Data, it shall be responsible for actual damages
        caused by the processing of Personal Data in breach of the provisions of the GDPR.</li>
    </ol>

    <b>§ 13. Creators and Users Personal Data</b>

    <ol>
      <li>The controller of the Personal Data of Creators and Users is the Service Provider.</li>

      <li>The data controller processes Creator’s Personal Data, i.e., name, surname, business address, email address, tax
        id, bank account number, and the Users’ data: name and email address, to enable them to use the Website and the
        rpgRoot System, including the provision of Services.</li>

      <li>The provision of Personal Data by Creators and Users is voluntary; however, it may not be possible to use
        particular Services without providing such data.</li>

      <li>The Service Provider shall endeavour to ensure the security and confidentiality of Personal Data, particularly
        by carrying out processing pursuing the applicable laws (GDPR and sectoral regulations) and providing appropriate
        security measures.</li>

      <li>More information on the protection of the Personal Data of Creators and Users, together with information on the
        cookies policy, can be found in the Privacy Policy available on the Website at:
        https://rpgroot.com/#/privacy-policy/. The Creator /User declares that he has read the content of the document
        mentioned above.</li>
    </ol>

    <b>§ 14. Intellectual property rights</b>
    <ol>

      <li>The Service Provider reserves that the content of the Website and the rpgRoot System are protected by
        intellectual property law, e.g., computer software, graphic elements, logotypes, text, video, or audio content.
      </li>

      <li>The use of the Website and the rpgRoot System does not imply acquiring any intellectual property rights to the
        works contained therein. It is forbidden to copy, distribute, use or modify any components of the Website or the
        rpgRoot System without the Service Provider’s prior consent.</li>

      <li>The Service Provider grants the Creator and the User a non-exclusive licence (hereinafter referred to as the
        “Licence”) authorising them to use the Website and the rpgRoot System respectively, in a manner consistent with
        their intended purpose, including under the terms hereof, Price List and Instructions and other notices published
        on the Website, and the Licence granted shall not entitle them to grant any further licences (sub-licences).</li>

      <li>The Service Provider shall grant the Licence without territorial limitations for a definite term corresponding
        to the duration of provision of the Services. It shall expire upon deletion of the Account (cease of the
        Newsletter Service use, respectively).</li>
    </ol>

    <b>§ 15. Right of withdrawal</b>
    <ol>

      <li>The Creator, irrespective of being a Consumer or Entrepreneur, may withdraw from the Contract without giving
        reasons within fourteen days from the date of its conclusion.</li>

      <li>To preserve the 14-day deadline, one shall send a notice of withdrawal from the Contract before its expiry to
        the following address: support@rpgroot.com. Specimen notice of withdrawal is attached hereto as Schedule no. 1.
      </li>

      <li>If the Creator withdraws from the Contract, the Service Provider shall return the Fee charged for paid Services
        the purchase of which has been withdrawn from, within fourteen days of the receipt of the notice. The refund shall
        be made with no additional costs and in the same manner as for the payment of the Fee unless the Creator notifies
        the Service Provider of a different method of refund.</li>
    </ol>

    <b>§ 16. Out-of-court dispute resolution and enforcement of claims</b>
    <ol>

      <li>The Creator that is a Consumer is entitled to use out-of-court complaint and claims’ enforcement procedures,
        particularly with the support of municipal (district) Consumer Ombudsman or the European online platform for
        dispute resolution (ODR) between entrepreneurs and Consumers, available at the following web address:
        http://ec.europa.eu/consumers/odr</li>

      <li>The information on other available methods of out-of-court dispute resolution, including a list of Consumer
        ombudsmen and proceedings related to out-of-court dispute resolution, is available on the Office of Competition
        and Consumer Protection website at the following address:
        https://www.uokik.gov.pl/pozasadowe_rozwiazywanie_sporow_konsumenckich.php</li>

      <li>In matters not covered by these Terms of Service, generally applicable provisions of Polish law shall apply, in
        particular the provisions of the Civil Code, the Act on Consumer Rights, Act on Copyright or Act on Providing
        Electronic Services.</li>
    </ol>

    <b>§ 17. Final provisions</b>
    <ol>

      <li>The Terms of Service are available free of charge on the Website for each Creator.</li>

      <li>The Service Provider reserves the right to amend these Terms of Service subject to the protection of already
        acquired rights if at least one of the following occurs:</li>

      <li>changes in the provisions of law having a direct impact on the content of the Terms of Service or the Service
        Provider’s business;</li>

      <li>issuance of decisions or rulings of administrative bodies or courts, affecting the performance of the Contracts
        covered by these Terms of Service;</li>

      <li>implementation of new technological solutions concerning the Website, the rpgRoot</li>
      <li>System and Services covered by these Terms of Service;</li>

      <li>implementation of solutions aimed at improving the operation of the Website, the rpgRoot System and the services
        provided to Creators and Users;</li>

      <li>change of the Service Provider’s data;</li>

      <li>implementation of solutions aimed at improving the privacy and preventing abuses;</li>

      <li>limitation or extension of the Website’s offer or the scope of Services (including the introduction or
        withdrawal of functionalities being a part of the rpgRoot System);</li>

      <li>a need to remove ambiguities, errors, or typing mistakes that have appeared in the Terms of Service;</li>

      <li>changes to the methods of payment.</li>

      <li>The Service Provider shall inform the Creators of amendments to the Terms of Service no later than 14 days
        before their planned entry into force by: displaying a notice and publishing the new Terms of Service on the
        Website, and sending information about the planned amendment electronically to the email address assigned to the
        Account. The Creator may object to the amendments introduced until they come into force by informing the Service
        Provider by email to the following address: support@rpgroot.com. Submission of an objection constitutes
        termination of the Contract, including the one for the continuous provision of services (e.g., Newsletter).</li>

      <li>The Creator ‘s failure to object to the proposed amendments within 14 days of the notification shall be deemed
        acceptance of the new Terms of Service. If the objection is raised, the Contract shall be terminated on the day
        preceding the effective date of the new Terms of Service, which shall also result in discontinuation of the
        Account Service.</li>

      <li>Under a separate agreement concluded with the Creator, the Service Provider is entitled to settle the terms of
        using the Website and the rpgRoot System differently. In such case, if any conflicting provisions occur, the
        provisions of the abovementioned agreement shall prevail over the provisions of these Terms of Service.</li>

      <li>These Terms of Service are governed by Polish law. Any disputes under these Terms of Service shall be resolved
        by amicable negotiations and, in the case of Entrepreneurs, if no agreement is reached, before a common court with
        jurisdiction over the Service Provider’s registered office.</li>

      <li>In matters not covered by these Terms of Service, the provisions of generally applicable Polish law, including
        the Civil Code, the Act on Consumer Rights, the Act on Copyright, GDPR, and the Act on Provision of Electronic
        Services, shall apply.</li>

      <li>The content of these Terms of Service is available on the Website.</li>

      <li>The Terms of Service apply as of 10.06.2023.</li>
    </ol>
    <p>
      <a href="../../Notice-of-withdrawal.pdf">Appendix No. 1 to the Regulations: MODEL OF THE STATEMENT OF
        WITHDRAWAL FROM THE CONTRACT</a>
    </p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {}
})
export default class Terms extends Vue {}
</script>

<style scoped>
div {
  text-align: justify;
}

iframe {
  /* border: 1px solid red; */
  border: none;
  padding: 0px;
  width: 100%;
  height: 100vh;
}
</style>
